const GooglePlayLogo = () => {
  return (
    <svg width="162" height="40" viewBox="0 0 162 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="161.5" height="40" fill="#20282E" />
      <path
        d="M58.9078 14.0088C58.6175 13.7935 58.4116 13.4938 58.2852 13.1146L59.0295 12.8057C59.1793 13.3113 59.4789 13.5594 59.933 13.5594C60.1811 13.5594 60.3824 13.4751 60.5322 13.3019C60.682 13.1287 60.7569 12.904 60.7569 12.6278V9.04651H61.5621V12.595C61.5621 12.9602 61.4966 13.2738 61.3562 13.5313C61.2157 13.7888 61.0238 13.9854 60.7757 14.1212C60.5275 14.2569 60.2513 14.3225 59.9377 14.3225C59.5398 14.3225 59.198 14.2148 58.9078 13.9994V14.0088Z"
        fill="white"
      />
      <path
        d="M62.8301 9.04655H65.9666V9.81898H63.6353V11.2468H65.7325V12.0099H63.6353V13.4377H65.9666V14.2101H62.8301V9.04187V9.05123V9.04655Z"
        fill="white"
      />
      <path d="M68.1489 9.81894H66.707V9.04651H70.396V9.81894H68.9541V14.2148H68.1489V9.81894Z" fill="white" />
      <path
        d="M70.9902 13.3862L73.6867 9.81894H71.1073V9.04651H74.623V9.87512L71.9452 13.4423H74.6511V14.2148H70.9949V13.3862H70.9902Z"
        fill="white"
      />
      <path d="M76.772 9.81894H75.3301V9.04651H79.019V9.81894H77.5772V14.2148H76.772V9.81894Z" fill="white" />
      <path
        d="M81.4668 9.04652H83.4096C83.6811 9.04652 83.9386 9.10269 84.1727 9.22909C84.4067 9.35549 84.594 9.50997 84.7297 9.72532C84.8702 9.9313 84.9357 10.1747 84.9357 10.4228C84.9357 10.671 84.8702 10.8957 84.7438 11.0876C84.6174 11.2795 84.4442 11.42 84.2475 11.5089V11.5511C84.505 11.64 84.7204 11.7898 84.8795 12.0052C85.0387 12.2205 85.1183 12.4593 85.1183 12.7495C85.1183 13.0398 85.0434 13.2879 84.8936 13.5032C84.7438 13.7186 84.5472 13.8918 84.3037 14.0182C84.0556 14.1446 83.7888 14.2007 83.4892 14.2007H81.4668V9.03247V9.04183V9.04652ZM83.3721 11.214C83.6062 11.214 83.7888 11.1391 83.9292 10.9987C84.0697 10.8582 84.1446 10.6897 84.1446 10.5024C84.1446 10.3152 84.079 10.156 83.9386 10.0062C83.7981 9.8564 83.6249 9.79086 83.4002 9.79086H82.272V11.2093H83.3674L83.3768 11.2187L83.3721 11.214ZM83.4985 13.4611C83.7466 13.4611 83.9386 13.3862 84.0884 13.227C84.2382 13.0678 84.3131 12.8946 84.3131 12.698C84.3131 12.5014 84.2382 12.3188 84.0884 12.1596C83.9386 12.0098 83.7326 11.9349 83.4845 11.9349H82.2907V13.4611H83.5079H83.4985Z"
        fill="white"
      />
      <path
        d="M86.1641 9.04655H89.3006V9.81898H86.9693V11.2468H89.0665V12.0099H86.9693V13.4377H89.3006V14.2101H86.1641V9.04187V9.05123V9.04655Z"
        fill="white"
      />
      <path d="M90.4082 9.04651H91.2134V14.2148H90.4082V9.04651Z" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M110.179 17.5474H105.879V24.0019H110.179C110.179 24.0019 112.654 23.5854 112.654 20.7746C112.654 17.9639 110.179 17.5474 110.179 17.5474ZM106.713 22.5724V19.1087H109.632C109.632 19.1087 110.96 19.1087 110.96 20.8405C110.96 22.5724 109.632 22.5724 109.632 22.5724H106.713Z"
        fill="white"
      />
      <path d="M107.017 17.5474H105.5V28.0474H107.017V17.5474Z" fill="white" />
      <path d="M115.056 17.5474H113.539V28.0474H115.056V17.5474Z" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M102.103 23.7518L97.3063 25.7124C97.3063 25.7124 97.6161 26.7969 99.0584 26.8041C100.188 26.8098 100.825 25.8142 100.825 25.8142L102.042 26.6293C102.042 26.6293 101.06 28.2001 99.0488 28.2001C96.577 28.2001 95.4883 26.0627 95.4883 24.6745C95.4883 23.3371 96.3524 21.0724 98.8954 21.0724C101.438 21.0724 102.103 23.7518 102.103 23.7518ZM120.676 27.2967C120.259 27.6375 119.591 27.9584 118.536 28.0235C116.119 28.1728 116.118 25.9919 116.118 25.8448L116.117 25.8198C116.112 25.5592 116.075 23.9079 117.921 23.6364C119.282 23.4362 120.236 23.7698 120.676 23.9816V23.6731C120.568 23.2645 120.233 22.5137 119.228 22.5137C117.847 22.5137 117.542 23.2522 117.542 23.2522L116.278 22.5137C116.278 22.5137 116.985 21.0724 119.107 21.0724C121.744 21.0724 122.193 22.8716 122.193 23.4776V23.4864V28.044H120.676V27.2967ZM120.568 25.0476C120.568 25.0476 117.646 24.2687 117.544 25.8921C117.443 27.5156 120.348 26.736 120.607 25.5852C120.607 25.2193 120.568 25.0476 120.568 25.0476ZM122.335 21.2974L125.039 27.649L123.624 30.9724H125.141L129.245 21.3337H127.728L125.798 25.8677L123.852 21.2974H122.335ZM98.749 22.4558C99.6746 22.2883 100.278 23.1964 100.278 23.1964L97.0374 24.5045C97.0374 24.5045 96.791 22.81 98.749 22.4558Z"
        fill="white"
      />
      <path d="M94.8176 17.5474H93.2129V28.0256H94.8176V17.5474Z" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M73.1613 28.1974C71.1673 28.1974 69.5508 26.6024 69.5508 24.6349C69.5508 22.6674 71.1673 21.0724 73.1613 21.0724C75.1553 21.0724 76.7718 22.6674 76.7718 24.6349C76.7718 26.6024 75.1553 28.1974 73.1613 28.1974ZM80.9727 28.1974C78.9787 28.1974 77.3622 26.6024 77.3622 24.6349C77.3622 22.6674 78.9787 21.0724 80.9727 21.0724C82.9667 21.0724 84.5832 22.6674 84.5832 24.6349C84.5832 26.6024 82.9667 28.1974 80.9727 28.1974ZM92.128 21.3128L90.6447 21.3001V21.954C90.6447 21.954 89.9998 21.0362 88.6582 21.0735C86.9833 21.1201 85.2495 22.4003 85.2495 24.6385C85.2495 26.8767 87.0908 28.1896 88.6403 28.1896C90.0695 28.1896 90.6448 27.299 90.6448 27.299V28.0165C90.6448 28.5286 90.4507 30.0248 88.7878 30.0248C87.3275 30.0248 86.912 28.732 86.912 28.732L85.5497 29.2986C85.5497 29.2986 86.3229 31.3963 88.717 31.3963C91.1111 31.3963 92.128 29.6132 92.128 27.9241V21.3128ZM90.7256 24.6574C90.7256 25.8662 89.8487 26.8461 88.767 26.8461C87.6852 26.8461 86.8083 25.8662 86.8083 24.6574C86.8083 23.4486 87.6852 22.4687 88.767 22.4687C89.8487 22.4687 90.7256 23.4486 90.7256 24.6574ZM82.9785 24.6349C82.9785 25.8308 82.0699 26.8003 80.9491 26.8003C79.8283 26.8003 78.9197 25.8308 78.9197 24.6349C78.9197 23.439 79.8283 22.4695 80.9491 22.4695C82.0699 22.4695 82.9785 23.439 82.9785 24.6349ZM75.1671 24.6349C75.1671 25.8308 74.2585 26.8003 73.1377 26.8003C72.0169 26.8003 71.1083 25.8308 71.1083 24.6349C71.1083 23.439 72.0169 22.4695 73.1377 22.4695C74.2585 22.4695 75.1671 23.439 75.1671 24.6349Z"
        fill="white"
      />
      <path d="M63.8398 22.2019H68.6063L68.5593 23.6922H63.8398V22.2019Z" fill="white" />
      <path
        d="M67.668 18.6955L66.5773 19.7718C65.8969 19.0854 64.9306 18.7092 63.8157 18.7092C61.5871 18.7092 59.7804 20.4918 59.7804 22.6908C59.7804 24.8898 61.5871 26.6724 63.8157 26.6724C66.0443 26.6724 67.6266 25.4011 67.6232 22.6908C67.627 22.5233 67.6231 22.3602 67.6117 22.2018H69.0041C69.0043 22.2202 69.0044 22.2387 69.0044 22.2572C69.5281 26.052 66.9089 28.2371 63.7685 28.2092C60.6797 28.2048 58.1758 25.7385 58.1758 22.6908C58.1758 19.6431 60.6797 17.1724 63.7685 17.1724C65.383 17.1724 66.7402 17.729 67.668 18.6955Z"
        fill="white"
      />
      <path
        d="M50.6153 18.0372C51.7624 18.6824 51.7626 19.7283 50.6153 20.3737L34.3309 29.5336C33.1838 30.1788 32.2539 29.6447 32.2539 28.34V10.0712C32.2539 8.76678 33.1835 8.2322 34.3309 8.8775L50.6153 18.0372Z"
        fill="url(#paint0_linear_5013_20462)"
      />
      <mask
        id="mask0_5013_20462"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="32"
        y="8"
        width="20"
        height="22"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M50.6153 18.0372C51.7624 18.6824 51.7626 19.7283 50.6153 20.3737L34.3309 29.5336C33.1838 30.1788 32.2539 29.6447 32.2539 28.34V10.0712C32.2539 8.76678 33.1835 8.2322 34.3309 8.8775L50.6153 18.0372Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_5013_20462)">
        <path
          d="M32.2388 8.61487L42.8404 19.0354L32.1016 29.8669L32.2388 8.61487Z"
          fill="url(#paint1_linear_5013_20462)"
        />
      </g>
      <mask
        id="mask1_5013_20462"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="32"
        y="8"
        width="20"
        height="22"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M50.6153 18.0372C51.7624 18.6824 51.7626 19.7283 50.6153 20.3737L34.3309 29.5336C33.1838 30.1788 32.2539 29.6447 32.2539 28.34V10.0712C32.2539 8.76678 33.1835 8.2322 34.3309 8.8775L50.6153 18.0372Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_5013_20462)">
        <path
          d="M30.0586 6.46997L42.839 19.0385L46.6385 15.4535L30.0586 6.46997Z"
          fill="url(#paint2_linear_5013_20462)"
        />
      </g>
      <mask
        id="mask2_5013_20462"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="32"
        y="8"
        width="20"
        height="22"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M50.6153 18.0372C51.7624 18.6824 51.7626 19.7283 50.6153 20.3737L34.3309 29.5336C33.1838 30.1788 32.2539 29.6447 32.2539 28.34V10.0712C32.2539 8.76678 33.1835 8.2322 34.3309 8.8775L50.6153 18.0372Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask2_5013_20462)">
        <path
          d="M42.8413 19.0363L48.6581 24.8345L31.2812 30.6328L42.8413 19.0363Z"
          fill="url(#paint3_linear_5013_20462)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_5013_20462"
          x1="38.1249"
          y1="8.60378"
          x2="38.1249"
          y2="16.8547"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBDA09" />
          <stop offset="1" stopColor="#FFBC00" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_5013_20462"
          x1="17.0104"
          y1="50.5334"
          x2="46.9228"
          y2="49.4772"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#01E2FF" />
          <stop offset="1" stopColor="#01C4FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_5013_20462"
          x1="24.4595"
          y1="10.3519"
          x2="31.2554"
          y2="25.6047"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#28D781" />
          <stop offset="1" stopColor="#02F076" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_5013_20462"
          x1="30.1528"
          y1="12.8073"
          x2="24.7625"
          y2="33.1273"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2414E" />
          <stop offset="1" stopColor="#E02554" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default GooglePlayLogo
